export const GET_PAYMENT_LINK_REQUEST = "GET_PAYMENT_LINK_REQUEST";
export const GET_PAYMENT_LINK_SUCCESS = "GET_PAYMENT_LINK_SUCCESS";
export const GET_PAYMENT_LINK_ERROR = "GET_PAYMENT_LINK_ERROR";
export const CLEAR_PAYMENT_FLAG = "CLEAR_PAYMENT_FLAG";
